import { jsx as _jsx } from "react/jsx-runtime";
import React, { useRef } from 'react';
import SenderReceiverEditForm, {} from './SenderReceiverEditForm';
import { Modal } from "antd";
const SenderReceiverEditModal = ({ open, senderReceiverId, onUpdated, onCancel }) => {
    const senderReceiverEditFormRef = useRef(null);
    const saveAndClose = () => {
        senderReceiverEditFormRef.current?.save()
            .then(onUpdated)
            .catch(error => console.error(error));
    };
    return (_jsx(Modal, { title: "Saved Location Details", open: open, onOk: saveAndClose, onCancel: onCancel, destroyOnHidden: true, width: "95%", children: _jsx(SenderReceiverEditForm, { ref: senderReceiverEditFormRef, senderReceiverId: senderReceiverId }) }));
};
export default SenderReceiverEditModal;
